// src/pages/admin/Pedidos.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const ESTADOS = ['nuevo','preparando','en_proceso','enviado','entregado','cancelado'];
const LABELS = { nuevo:'Nuevo', preparando:'Preparando', en_proceso:'En proceso', enviado:'Enviado', entregado:'Entregado', cancelado:'Cancelado' };
const BADGES = { nuevo:'badge-blue', preparando:'badge-yellow', en_proceso:'badge-yellow', enviado:'badge-green', entregado:'badge-green', cancelado:'badge-red' };

export default function Pedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [detalle, setDetalle] = useState(null);

  const load = () => api.get('/pedidos?limit=100').then(r => setPedidos(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const [modalEnvio, setModalEnvio] = useState(null); // { id, ciudad }
  const [guiaForm, setGuiaForm] = useState({ guia:'', transportadora:'' });

  const cambiarEstado = async (id, estado, guia='', transportadora='') => {
    await api.put('/pedidos/' + id + '/estado', { estado, numero_guia: guia, transportadora });
    toast.success('Estado actualizado');
    load();
    if (detalle?.id === id) {
      const r = await api.get(`/pedidos/${id}`);
      setDetalle(r.data);
    }
  };

  const eliminarPedido = async (id) => {
    if (!window.confirm('Eliminar este pedido? Esta accion no se puede deshacer.')) return;
    try {
      await api.delete('/pedidos/' + id);
      toast.success('Pedido eliminado');
      setDetalle(null);
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Error al eliminar'); }
  };

  const verDetalle = async (id) => {
    const r = await api.get(`/pedidos/${id}`);
    setDetalle(r.data);
  };

  const filtrados = filtro ? pedidos.filter(p => p.estado === filtro) : pedidos;

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Pedidos</h1>
        <div style={{ display:'flex', gap:8 }}>
          <select className="form-input" style={{ width:160 }} value={filtro} onChange={e=>setFiltro(e.target.value)}>
            <option value="">Todos los estados</option>
            {ESTADOS.map(e => <option key={e} value={e}>{LABELS[e]}</option>)}
          </select>
        </div>
      </div>
      <div style={{ padding:'24px 28px', display:'grid', gridTemplateColumns: detalle ? 'repeat(auto-fit, minmax(300px, 1fr))' : '1fr', gap:20 }}>
        <div className="card">
          <div style={{ overflowX:"auto", WebkitOverflowScrolling:"touch" }}>
          <table className="table" style={{ minWidth:700 }}>
            <thead><tr><th>#</th><th>Cliente</th><th>Ciudad</th><th>Total</th><th>Pago</th><th>Estado</th><th>Fecha</th><th></th></tr></thead>
            <tbody>
              {filtrados.map(p => (
                <tr key={p.id} style={{ cursor:'pointer' }} onClick={() => verDetalle(p.id)}>
                  <td style={{ fontWeight:700, color:'var(--green)' }}>{p.numero}</td>
                  <td>{p.nombre_cliente}<br/><span style={{ fontSize:11, color:'var(--text-muted)' }}>{p.email_cliente}</span></td>
                  <td style={{ fontSize:12 }}>{p.ciudad_entrega}</td>
                  <td style={{ fontWeight:700 }}>{fmtCOP(p.total)}</td>
                  <td><span className={`badge ${p.estado_pago==='pagado'?'badge-green':'badge-yellow'}`}>{p.estado_pago==='pagado'?'Pagado':'Pendiente'}</span></td>
                  <td><span className={`badge ${BADGES[p.estado]||'badge-gray'}`}>{LABELS[p.estado]||p.estado}</span></td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{new Date(p.created_at).toLocaleDateString('es-CO')}</td>
                  <td><button className="btn btn-outline btn-sm">Ver</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>

        {detalle && (
          <div className="card">
            <div className="card-header">
              <span className="card-title">{detalle.numero}</span>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <button onClick={() => eliminarPedido(detalle.id)} style={{ padding:'5px 12px', borderRadius:'var(--r-sm)', border:'none', background:'#fcebeb', color:'#a32d2d', fontWeight:700, fontSize:12, cursor:'pointer' }}>🗑️ Eliminar</button>
                <button onClick={() => setDetalle(null)} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'var(--text-muted)' }}>×</button>
              </div>
            </div>
            <div className="card-body">
              <div style={{ fontSize:13, lineHeight:2, color:'var(--text-muted)' }}>
                <div><strong style={{ color:'var(--text)' }}>Cliente:</strong> {detalle.nombre_cliente}</div>
                <div><strong style={{ color:'var(--text)' }}>Email:</strong> {detalle.email_cliente}</div>
                <div><strong style={{ color:'var(--text)' }}>Tel:</strong> {detalle.telefono_cliente}</div>
                <div><strong style={{ color:'var(--text)' }}>Dirección:</strong> {detalle.direccion_entrega}</div>
                <div><strong style={{ color:'var(--text)' }}>Ciudad:</strong> {detalle.ciudad_entrega}</div>
              </div>

              <div style={{ marginTop:16 }}>
                <div style={{ fontWeight:700, marginBottom:8, fontSize:13 }}>Productos:</div>
                {detalle.items?.map(item => (
                  <div key={item.id} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid var(--border)', fontSize:13 }}>
                    <span>{item.nombre_producto} x{item.cantidad}</span>
                    <span style={{ fontWeight:700 }}>{fmtCOP(item.subtotal)}</span>
                  </div>
                ))}
                <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0', fontWeight:900, fontSize:15 }}>
                  <span>Total</span>
                  <span style={{ color:'var(--green)' }}>{fmtCOP(detalle.total)}</span>
                </div>
              </div>

              <div style={{ marginTop:16 }}>
                <div style={{ fontWeight:700, marginBottom:8, fontSize:13 }}>Cambiar estado:</div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                  {ESTADOS.map(e => (
                    <button key={e} className={`btn btn-sm ${detalle.estado===e?'btn-primary':'btn-outline'}`}
                      onClick={() => {
                        if (e === 'enviado') {
                          setGuiaForm({ guia: detalle.numero_guia || '', transportadora: detalle.transportadora || '' });
                          setModalEnvio({ id: detalle.id, ciudad: detalle.ciudad_entrega });
                        } else {
                          cambiarEstado(detalle.id, e);
                        }
                      }}>
                      {LABELS[e]}
                    </button>
                  ))}
                </div>
              </div>

              {detalle.estado === 'enviado' && (
                <div style={{ marginTop:12 }}>
                  <div className="form-group">
                    <label className="form-label">Nro. de guía</label>
                    <input className="form-input" placeholder="Número de guía" onBlur={e => cambiarEstado(detalle.id, 'enviado', e.target.value, detalle.transportadora)} defaultValue={detalle.numero_guia} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Transportadora</label>
                    <select className="form-input" defaultValue={detalle.transportadora} onChange={e => cambiarEstado(detalle.id, 'enviado', detalle.numero_guia, e.target.value)}>
                      <option value="">Seleccionar</option>
                      <option>Interrapidísimo</option>
                      <option>Coordinadora</option>
                      <option>Servientrega</option>
                      <option>Envía</option>
                      <option>TCC</option>
                      <option>Deprisa</option>
                      <option>Mensajero local</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {/* Modal envio */}
      {modalEnvio && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div className="card" style={{ width:'100%', maxWidth:440 }}>
            <div className="card-header">
              <span className="card-title">Marcar como enviado</span>
              <button onClick={() => setModalEnvio(null)} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer' }}>✕</button>
            </div>
            <div className="card-body">
              <p style={{ fontSize:13, color:'var(--ink-faint)', marginBottom:16 }}>
                Destino: <strong>{modalEnvio.ciudad}</strong>
                {modalEnvio.ciudad?.toLowerCase() === 'pasto' && <span style={{ marginLeft:8, fontSize:11, background:'rgba(159,190,106,0.2)', color:'var(--forest)', padding:'2px 8px', borderRadius:20, fontWeight:700 }}>Entrega local</span>}
              </p>
              <div className="form-group">
                <label className="form-label">Transportadora *</label>
                <select className="form-input" value={guiaForm.transportadora} onChange={e=>setGuiaForm(f=>({...f,transportadora:e.target.value}))}>
                  <option value="">Seleccionar transportadora</option>
                  <option>Interrapidísimo</option>
                  <option>Coordinadora</option>
                  <option>Servientrega</option>
                  <option>Envía</option>
                  <option>TCC</option>
                  <option>Deprisa</option>
                  <option>Mensajero local</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Número de guía {modalEnvio.ciudad?.toLowerCase() !== 'pasto' ? '*' : '(opcional)'}</label>
                <input className="form-input" placeholder="Ej: 123456789" value={guiaForm.guia} onChange={e=>setGuiaForm(f=>({...f,guia:e.target.value}))} />
              </div>
              {modalEnvio.ciudad?.toLowerCase() !== 'pasto' && (
                <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:8, padding:12, fontSize:13, color:'var(--forest)', marginBottom:12 }}>
                  ✉️ Se enviará correo al cliente con la guía de envío
                </div>
              )}
              <div style={{ display:'flex', gap:10, marginTop:8 }}>
                <button className="btn btn-primary" style={{ flex:1, background:'#9FBE6A', color:'#1C3A1E' }}
                  onClick={async () => {
                    if (!guiaForm.transportadora) { alert('Selecciona la transportadora'); return; }
                    if (modalEnvio.ciudad?.toLowerCase() !== 'pasto' && !guiaForm.guia) { alert('Ingresa el número de guía'); return; }
                    await cambiarEstado(modalEnvio.id, 'enviado', guiaForm.guia, guiaForm.transportadora);
                    setDetalle(d => ({...d, estado:'enviado', numero_guia:guiaForm.guia, transportadora:guiaForm.transportadora}));
                    setModalEnvio(null);
                    load();
                  }}>
                  Confirmar envío
                </button>
                <button className="btn btn-outline" onClick={() => setModalEnvio(null)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
